<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('queryJob.BatchCollaboration')"
    width="600px"
    custom-class="batch-cooperation-dialog"
    :close-on-click-modal="false"
  >
    <el-form label-width="100px" label-position="left" class="cargo-form">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_CooperateBranchId') }}</span>
            <cargo-advance-select
              no="branchId"
              :select-type="TYPE_NAMES.basic_data_Office"
              :clearable="false"
              filterable
              :default-value="Number(job.branchId)"
              :cache="false"
              :static-options="officeList"
              :placeholder="' '"
              @parentCallBack="p => { job.branchId = p.value; reSet() }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_CooperateBusinessType') }}</span>
            <cargo-advance-select
              no="businessType"
              :select-type="TYPE_NAMES.basic_data_CooperationType"
              :multiple="true"
              :clearable="false"
              filterable
              :default-multiple-value="job.businessType"
              :placeholder="' '"
              @parentCallBack="p => { job.businessType = p.value }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.Operation') }}</span>
            <cargo-user-select
              no="opId"
              :method-params="{ officeId: job.branchId, category: 'role', shape: 'op' }"
              :default-value="job.opId || ''"
              :placeholder="' '"
              @change="p => { job.opId = p.value; opChangeHandler(p.value) }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.CustomerService')">
            <cargo-user-select
              no="csrId"
              :method-params="{ officeId: job.branchId, category: 'role', shape: 'csr' }"
              :default-value="job.csrId || ''"
              :placeholder="' '"
              @change="p => { job.csrId = p.value }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
            <cargo-user-select
              no="overseaOp"
              :method-params="{ officeId: job.branchId, category: 'role', shape: 'overseaOp' }"
              :default-value="job.overseaOp || ''"
              :placeholder="' '"
              @change="p => { job.overseaOp = p.value }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Documents')">
            <cargo-user-select
              no="dcId"
              :method-params="{ officeId: job.branchId, category: 'role', shape: 'doc' }"
              :default-value="job.dcId || ''"
              :placeholder="' '"
              @change="p => { job.dcId = p.value }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.AirlinePerson2')">
            <cargo-user-select
              no="planner"
              :method-params="{ officeId: job.branchId, category: 'role', shape: 'seaLine' }"
              :default-value="job.planner || ''"
              :placeholder="' '"
              @change="p => { job.planner = p.value }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Sales')">
            <cargo-user-select
              no="sales"
              :method-params="{officeId:job.branchId,category:'role',shape:'sales'}"
              :default-value="job.sales||''"
              :placeholder="' '"
              @change="p=>{salesChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.SalesOfGoods')">
            <cargo-user-select
              no="cargoSalesId"
              :method-params="{category:'role',shape:'salesOfGoods'}"
              :default-value="job.cargoSalesId||''"
              :placeholder="' '"
              @change="p=>{cargoSalesChargeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole1')">
            <cargo-user-select
              no="userDefinedRole1"
              :method-params="{officeId:job.branchId,category:'role',shape:'userDefinedRole1'}"
              :default-value="job.userDefinedRoleId1||''"
              :placeholder="' '"
              @change="p=>{userDefinedRoleId1Handler(p)}"
            />&nbsp;
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole2')">
            <cargo-user-select
              no="userDefinedRole2"
              :method-params="{officeId:job.branchId,category:'role',shape:'userDefinedRole2'}"
              :default-value="job.userDefinedRoleId2||''"
              :placeholder="' '"
              @change="p=>{userDefinedRoleId2Handler(p)}"
            />&nbsp;
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Remarks')">
            <el-input v-model="job.remark" type="textarea" no="remark" :rows="4" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" style="padding:10px;">
      <el-button type="primary" no="confirm" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="cancel" @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
    <!-- 部分成功、部分失败弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="failDialog.visible"
      :title="$t('Message.Prompt')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-input v-model="failDialog.content" :disabled="true" type="textarea" :rows="10" />
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="copyFailJobNos">{{ $t('SeaExport.CopyFailedBusinessNumber') }}</el-button>
        <el-button @click="failDialog.visible = false">{{ $t('Message.Close') }}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { User } from '@/class/model/sys/User'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { batchSave } from '@/api/booking/jobCooperate'
import { Office } from '@/class/model/sys/Office'

export default {
  name: 'BatchCooperationBranchDialog',
  components: { cargoUserSelect, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    jobList: { type: Array, default: () => [] },
    orderCenterBranch: { type: Boolean, default: false }
  },
  data() {
    const defaultJob = {
      uuid: '',
      branchId: 0,
      businessType: [],
      opId: 0,
      opDepartment: 0,
      csrId: 0,
      overseaOp: 0,
      dcId: 0,
      planner: 0,
      remark: '',
      entrustBranchId: 0, // 委托分公司
      cooperateStatus: 0, // 协作状态
      businessStatus: 0, // 业务状态
      chargeStatus: 0, // 费用状态
      jobUuid: ''
    }
    return {
      TYPE_NAMES,
      defaultJob,
      job: { ...defaultJob, businessType: [] },
      innerVisible: false,
      officeList: [],
      failDialog: {
        visible: false,
        content: '',
        jobNos: ''
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    init() {
      this.officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      // 其他分公司
      this.officeList = this.officeList.filter(p => p.code !== 'HQ' && p.code !== this.$store.getters.currentOffice.code).sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
      Object.assign(this.job, this.defaultJob, { businessType: [] })
      if (this.officeList.length > 0) {
        this.job.branchId = this.officeList[0].officeId
      }
      this.job.entrustBranchId = this.$store.getters.currentOfficeId
    },
    async handleSubmit() {
      if (!this.job.branchId || this.job.branchId === 1 || this.job.branchId <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CooperateBranchCannotBeEmpty'))
        return
      }
      if (!this.job.businessType || this.job.businessType.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CooperateBusinessTypeCannotBeEmpty'))
        return
      }
      if (!this.job.opId || this.job.opId <= 0) {
        this.$message.warning(this.$t('SeaExport.OperationCannotBeEmpty'))
        return
      }
      const businessType = this.job.businessType.toString()

      const data = []
      const masterJobNos = [] // 为主票
      const orderCenterBranchJobNos = [] // 是接单分公司，但未开启接单分公司配置
      const opOfficeCooperateJobNos = [] // 不是接单分公司，也没有操作公司协作管理权限
      const notOpOfficeJobNos = [] // 操作公司不能是协作分公司
      const successJobNos = [] // 执行成功
      const existJobNos = [] // 已存在接受分公司是协作分公司的记录
      for (const item of this.jobList) {
        if (item.masterFlag) {
          masterJobNos.push(item.jobNo)
          continue
        }
        if (!this.orderCenterBranch) {
          if (item.cooperateStatus === -1) {
            orderCenterBranchJobNos.push(item.jobNo)
            continue
          }
        }
        if (item.cooperateStatus !== -1 && !this.$checkPermission(['button_Job_opOfficeCooperate'])) {
          opOfficeCooperateJobNos.push(item.jobNo)
          continue
        }
        if (item.opOffice === this.job.branchId) {
          notOpOfficeJobNos.push(item.jobNo)
          continue
        }
        data.push({ ...this.job, businessType, jobUuid: item.uuid })
      }
      if (data.length > 0) {
        const loading = getLoading4Cxt(this)
        try {
          await batchSave(data).then(res => {
            const { successJobs, existJobs, cooperates } = res.data
            for (const item of this.jobList) {
              let isContinue = true
              for (const successJobKey of successJobs) {
                if (successJobKey === item.uuid) {
                  successJobNos.push(item.jobNo)
                  if (cooperates.length > 0) {
                    item.cooperateStatus = cooperates[0].cooperateStatus
                  }
                  isContinue = false
                  break
                }
              }
              if (isContinue) {
                for (const existJobKey of existJobs) {
                  if (existJobKey === item.uuid) {
                    existJobNos.push(item.jobNo)
                    break
                  }
                }
              }
            }
          })
        } finally {
          loading.close()
        }
      }
      if (successJobNos.length === this.jobList.length) {
        this.$message.success(this.$t('queryJob.SuccessCooperateX', [successJobNos.length]))
        this.handleClose()
      } else {
        const failJobNos = [...masterJobNos, ...orderCenterBranchJobNos, ...opOfficeCooperateJobNos, ...notOpOfficeJobNos, ...existJobNos]
        let msg = this.$t('queryJob.SuccessCooperateXFailY', [successJobNos.length, failJobNos.length])
        if (masterJobNos.length > 0) {
          msg += '\n' + this.$t('queryJob.BusinessIsMaster', [masterJobNos.join(',')])
        }
        if (orderCenterBranchJobNos.length > 0) {
          msg += '\n' + this.$t('queryJob.OrderCenterBranchNotAvailable', [orderCenterBranchJobNos.join(',')])
        }
        if (opOfficeCooperateJobNos.length > 0) {
          msg += '\n' + this.$t('queryJob.NotBranchCollaborationManageme', [opOfficeCooperateJobNos.join(',')])
        }
        if (notOpOfficeJobNos.length > 0) {
          msg += '\n' + this.$t('queryJob.OpOfficeNotCooperateBranch', [notOpOfficeJobNos.join(',')])
        }
        if (existJobNos.length > 0) {
          const branchName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', this.job.branchId, 'chineseName')
          msg += '\n' + this.$t('queryJob.ExistCollaborationBranchRecord', [existJobNos.join(','), branchName])
        }
        this.failDialog.content = msg
        this.failDialog.jobNos = failJobNos.join(',')
        this.failDialog.visible = true
      }
    },
    handleClose() {
      this.innerVisible = false
    },
    opChangeHandler(opId) {
      // 默认操作部门
      new User({ userId: opId }).getUserDefaultDepartmentByOffice('role', 'op', this.job.branchId).then(dep => {
        this.job.opDepartment = dep ? dep.departmentId : 0
      })
    },
    // 重置
    reSet() {
      this.job.opId = 0
      this.job.csrId = 0
      this.job.overseaOp = 0
      this.job.dcId = 0
      this.job.planner = 0
      this.job.opDepartment = 0
      this.job.sales = 0
      this.job.salesOffice = 0
      this.job.salesDepartment = 0
      this.job.cargoSalesId = 0
      this.job.cargoSalesDepartment = 0
      this.job.cargoSalesOffice = 0
      this.job.userDefinedRoleId1 = 0
      this.job.userDefinedRoleDept1 = 0
      this.job.userDefinedRoleOffice1 = 0
      this.job.userDefinedRoleId2 = 0
      this.job.userDefinedRoleDept2 = 0
      this.job.userDefinedRoleOffice2 = 0
    },
    copyFailJobNos() {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', this.failDialog.jobNos)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message.success(this.$t('SeaExport.CopySuccess'))
      }
      document.body.removeChild(input)
    },
    async salesChangeHandler(data) {
      const job = this.job
      job.sales = data.value
      job.salesOffice = 0
      job.salesDepartment = 0
      if (data.value) {
        if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
          job.salesOffice = data.defaultOfficeId
          job.salesDepartment = data.defaultDepId
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
          if (offices.length > 1) {
            for (const item of offices) {
              if (item.officeId === this.job.branchId) {
                job.salesOffice = item.officeId
                job.salesDepartment = item.departmentId
                break
              }
            }
          } else {
            const user = new User(data)
            const department = await user.getDefaultDepartment('role', 'sales')
            job.salesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            if (office) {
              job.salesOffice = office.officeId
            }
          }
        }
      }
    },
    async cargoSalesChargeHandler(data) {
      const job = this.job
      job.cargoSalesId = data.value || 0
      job.cargoSalesDepartment = 0
      job.cargoSalesOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.job.branchId) {
              const office = await Office.getOfficeById(item.officeId)
              job.cargoSalesOffice = office ? office.officeId : 0
              job.cargoSalesDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'salesOfGoods')
          if (department) {
            job.cargoSalesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            job.cargoSalesOffice = office ? office.officeId : 0
          }
        }
      }
    },
    // 自定义岗位字段1
    async userDefinedRoleId1Handler(data) {
      const job = this.job
      job.userDefinedRoleId1 = data.value || 0
      job.userDefinedRoleDept1 = 0
      job.userDefinedRoleOffice1 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.job.branchId) {
              job.userDefinedRoleDept1 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice1 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
          job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice1 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段2
    async userDefinedRoleId2Handler(data) {
      const job = this.job
      job.userDefinedRoleId2 = data.value || 0
      job.userDefinedRoleDept2 = 0
      job.userDefinedRoleOffice2 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.job.branchId) {
              job.userDefinedRoleDept2 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice2 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
          job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice2 = office ? office.officeId : 0
        }
      }
    }
  }
}
</script>

<style lang="scss">
.batch-cooperation-dialog {
  .el-dialog {
    &__header,
    &__body,
    &__footer {
      padding: 10px 15px !important;
    }
    &__title {
      vertical-align: middle;
    }
    &__headerbtn {
      top: 15px;
      right: 15px;
    }
  }
}
.cargo-form {
  .el-form-item {
    &.red-input {
      .el-input__inner {
        color: #E9650E;
      }
    }
    &__content {
      width: auto !important;
    }
    &.label-none {
      .el-form-item__content {
        margin-left: 0;
      }
    }
  }
}
</style>
